import { MINUTES_PER_DAY, snapMinute } from '../../../domain/scheduling/scheduleMath';

export const HOURS: readonly number[] = Array.from({ length: 24 }, (_, hour) => hour);

/** Horizontal position (0-100) of a minute-of-day on the 24 h axis. */
export function minuteToPercent(minute: number): number {
  return (minute / MINUTES_PER_DAY) * 100;
}

/** Converts a pointer x-position over a lane into a snapped minute-of-day. */
export function pointerToMinute(clientX: number, laneLeft: number, laneWidth: number): number {
  if (laneWidth <= 0) return 0;
  const ratio = Math.min(1, Math.max(0, (clientX - laneLeft) / laneWidth));
  return snapMinute(ratio * MINUTES_PER_DAY);
}
